import { NavLink } from 'react-router-dom'
import { Group } from '@mantine/core'
import { can } from '@racedash/shared'
import type { Role } from '@racedash/shared'

/**
 * Sub-navigation for an organisation. Previously these were footer links, which
 * left no visible way to reach People or the trash from the dashboard list.
 *
 * Still react-router NavLinks: routing is the router's job, and Mantine's own
 * NavLink is a sidebar control rather than a row of tabs.
 */
export default function OrgNav({ orgId, role }: { orgId: string; role: Role | null }) {
  const cls = ({ isActive }: { isActive: boolean }) =>
    isActive ? 'subnav-item active' : 'subnav-item'

  return (
    <Group gap={2} component="nav" mb="md">
      <NavLink to={`/o/${orgId}`} end className={cls}>
        Dashboards
      </NavLink>
      <NavLink to={`/o/${orgId}/events`} className={cls}>
        Events
      </NavLink>
      <NavLink to={`/o/${orgId}/team`} className={cls}>
        Team
      </NavLink>
      <NavLink to={`/o/${orgId}/people`} className={cls}>
        People
      </NavLink>
      {can(role, 'dashboard.restore') && (
        <NavLink to={`/o/${orgId}/trash`} className={cls}>
          Deleted
        </NavLink>
      )}
    </Group>
  )
}
